import { LuCalendarPlus, LuHandCoins, LuReceipt, LuUserPlus } from 'react-icons/lu';

import { isManager } from 'src/features/auth/roles';
import { useSession } from 'src/features/auth/useAuth';
import ActionSheet, { ActionSheetItem } from 'src/shared/components/ui/ActionSheet';
import type { QuickAction } from 'src/shared/hooks/useQuickAction';

interface CreateSheetProps {
  isOpen: boolean;
  toggle: () => void;
  onChoose: (action: QuickAction) => void;
}

/** What "+" offers: everything that starts something new, most frequent first. */
export default function CreateSheet({ isOpen, toggle, onChoose }: CreateSheetProps) {
  const user = useSession();

  return (
    <ActionSheet isOpen={isOpen} toggle={toggle} title="Crear">
      <ActionSheetItem
        icon={LuCalendarPlus}
        label="Nueva cita"
        hint="Clienta, servicios y horario"
        onClick={() => onChoose('nueva-cita')}
      />
      <ActionSheetItem
        icon={LuUserPlus}
        label="Nueva clienta"
        hint="Nombre y cómo contactarla"
        onClick={() => onChoose('nueva-clienta')}
      />
      <ActionSheetItem
        icon={LuHandCoins}
        label="Cobrar una cita"
        hint="Citas de hoy y de la última semana con saldo"
        onClick={() => onChoose('cobrar')}
      />
      {/* Mirrors `RESOURCE_ROLES["expenses:manage"]`. */}
      {isManager(user?.role) && (
        <ActionSheetItem
          icon={LuReceipt}
          label="Registrar gasto"
          hint="Compras, arriendo, servicios básicos"
          onClick={() => onChoose('nuevo-gasto')}
        />
      )}
    </ActionSheet>
  );
}
